import { createContainer } from 'react-sweet-state';

import { ListViewStore, PRIVATE_ACTIONS } from './ListViewStore';

export const ListViewStoreContainer = createContainer(ListViewStore, {
  onInit:
    () =>
    ({ setState, dispatch }, { state }) => {
      dispatch(PRIVATE_ACTIONS.init());

      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
});
